import { render, staticRenderFns } from "./Formulaire.vue?vue&type=template&id=6aa52976&"
import script from "./Formulaire.vue?vue&type=script&lang=ts&"
export * from "./Formulaire.vue?vue&type=script&lang=ts&"
import style0 from "./Formulaire.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports